import React from 'react';
import './App.css';
import {ThemeProvider} from '@mui/material';
import theme from "./theme/theme";
import {AppRouter} from "./routes/AppRouter";
import {MaiSnackbar} from "./components/snackbar/MaiSnackbar";
import {BrowserRouter} from "react-router-dom";
import {UserProvider} from "./context/useAuth";

function App() {

    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <UserProvider>
                    <AppRouter />
                    <MaiSnackbar />
                </UserProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;